import React from "react";
import { useMsal } from "@azure/msal-react";
import { CredentialManager } from "../classes/credentialManager";

export const SignOutButton = () => {
	const { instance } = useMsal();
	const credentialManager = CredentialManager.getInstance();

	const handleLogout = async (logoutType: string) => {
		if (logoutType === "popup") {
			await credentialManager.clearCredentials();
			instance.logoutPopup({
				postLogoutRedirectUri: "/",
				mainWindowRedirectUri: "/",
			});
		} else if (logoutType === "redirect") {
			instance.logoutRedirect({
				postLogoutRedirectUri: "/",
			});
		}
	};

	return (
		<button onClick={() => handleLogout("popup")}>
			Sign Out
		</button>
	);
};